import { BUILDING_QUARTER_PRESENTER, IOfferBuilding } from '../../types/offers';

export const getBuildingDeadline = (building?: IOfferBuilding): string | null => {
  if (!building || !building.deadline) {
    return null;
  }

  if (building.deadline.isComplete) {
    return 'дом сдан';
  }

  const quarterText = building.deadline.quarter
    ? `сдача ГК: ${BUILDING_QUARTER_PRESENTER[building.deadline.quarter] || ''} кв. `
    : '';
  const yearText = building.deadline.year
    ? `${building.deadline.year} года`
    : building.buildYear
      ? `${building.buildYear} года`
      : '';

  const text = `${quarterText}${yearText}`.trim();

  return text || null;
};
